class ValidationError extends Error {

    public errors:any[] = [];

    constructor(errors:any[]) {
        super('');
        this.errors = errors;
    }
}
export default ValidationError;